export default __webpack_public_path__ + "static/media/Christian Geis.65b1ae3c.png";